import React from 'react'

const propTypes = {
  unsetSelectedEntity: React.PropTypes.func.isRequired,
  setCenterHeight: React.PropTypes.func.isRequired,
}

class Localizer extends React.Component {

  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
    this.gotoUserPosition = this.gotoUserPosition.bind(this)
  }

  handleClick(event) {
    this.props.unsetSelectedEntity()
    
    fetch('https://geoip.nekudo.com/api/')  
      .then(function(response) {
        return response.json()
      })
      .then((position) => {
        this.gotoUserPosition(position.location.latitude, position.location.longitude)
      })
  }
    
  gotoUserPosition(lat, lng) {
    this.props.setCenterHeight({lat, lng}, null, 2)
  }

  shouldComponentUpdate() {
    return false
  }
    
  render() {

    return (
      <div className="Localizer">

        <button onClick={this.handleClick}>
          
        </button>

      </div>
    )

  }    
}

Localizer.propTypes = propTypes

export default Localizer


// WEBPACK FOOTER //
// ./src/components/Localizer.js